
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/forum/novo-topico",
      function () {
        return require("private-next-pages/forum/novo-topico.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/forum/novo-topico"])
      });
    }
  